<template>
  <div id="list-billing">
    <div class="d-flex">
      <div class="p-2 w-50">
        <vs-input
          icon-after="true"
          class="mt-2 w-100"
          size="small"
          label-placeholder="icon-after"
          icon="mode_edit"
          placeholder="Buscar coincidencias"
          v-model="textSearch"
          v-on:keyup.enter="fetchDocuments()"
          data-cy="search"
        />
        <vs-button
          v-if="searchParam"
          radius
          class="ml-3"
          color="primary"
          type="border"
          icon="highlight_off"
          size="small"
          @click="clearSearch()"
          data-cy="search-clear"
        />
      </div>
      <div
        class="ml-3 ml-auto"
        v-has-permission="'WBF101'"
      >
        <vs-button
          radius
          color="primary"
          flat
          @click="onNewBilling"
          data-cy="new-billing"
        >
          Nueva Facturación
        </vs-button>
      </div>
    </div>
    <BillingFilters
      :value="filters"
      :onChange="onChangeFilters"
      :clear="clearFilters"
    />
    <BillingHeader
      :exportable="true"
      @export-list="exportList"
    />
    <div
      class="force-render"
      :key="forceRender"
    >
      <BillingRow
        :key="file.febosId"
        v-for="file in list"
        :file="file"
        :select-file="selectFile"
        data-cy="file"
      />
    </div>
    <PopUpBinnacleBilling />
    <PopUpNewBilling />
    <vs-row>
      <vs-col vs-lg="3">
        <div class="mt-5">
          Mostrando <select
          v-model="rowspp"
          @change="fetchDocuments()"
        >
          <option
            value="10"
          >10
          </option>
          <option value="15">15</option>
          <option value="30">30</option>
          <option value="50">50</option>
        </select> registros por página.
        </div>
      </vs-col>
      <vs-col vs-lg="9">
        <BillingPagination v-model="page" />
      </vs-col>
    </vs-row>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import BillingHeader from '@/febos/global/billing/components/BillingHeader';
import BillingRow from '@/febos/global/billing/components/BillingRow';
import BillingFilters from '@/febos/global/billing/components/BillingFilters';
import BillingPagination from '@/febos/global/billing/components/BillingPagination';
import PopUpNewBilling from '@/febos/global/billing/vistas/modals/PopUpNewBilling';
import PopUpBinnacleBilling from '@/febos/global/billing/vistas/modals/PopUpBinnacleBilling';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { clListarDocumentosRecurrentes } from '@/febos/servicios/api/dte.api';

export default {
  name: 'Files',
  components: {
    BillingPagination,
    BillingFilters,
    PopUpBinnacleBilling,
    BillingHeader,
    BillingRow,
    PopUpNewBilling
  },
  data() {
    return {
      selectedFile: {},
      filters: '',
      textSearch: '',
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10),
      searchParam: false,
      page: Number.parseInt(this.$route.query.page || 1, 10),
      forceRender: Date.now() // TODO: the files watch is triggered but the component not re-render.
    };
  },
  watch: {
    textSearch(oldValue, newVaue) {
      if (oldValue !== newVaue) {
        this.searchParam = false;
      }
    },
    files() {
      this.forceRender = Date.now(); // TODO: remove this.
    },
    async page(page) {
      updateSearchParams({ page });
      await this.fetchDocuments();
    },
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#list-billing > .con-vs-loading');
        return;
      }
      this.$vs.loading({
        container: '#list-billing',
        scale: 0.6
      });
    },
    successAction() {
      this.$bvToast.toast(
        'Acción realizada exitosamente',
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
    },
    error(error) {
      if (error !== '') {
        this.$bvToast.toast(
          `${error}`,
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        this.clearErrorMessage();
      }
    }
  },
  computed: {
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('Billing', ['list', 'pagination', 'loading']),
    isConvention() {
      return this.company.iut === '60100003-2';
    },
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    }

  },
  methods: {
    ...mapActions('Modals', [
      'showModals',
      'closeModal'
    ]),
    ...mapActions('Billing', [
      'openNewBilling',
      'fetchBillings'
    ]),
    onNewBilling() {
      this.openNewBilling();
    },
    async reload() {
      await this.fetchDocuments();
    },
    async clearSearch() {
      this.searchParam = false;
      this.textSearch = '';
      await this.fetchDocuments();
    },
    async searchCoincidences() {
      this.searchParam = true;
      await this.fetchDocuments();
    },
    selectFile(file) {
      this.selectedFile = file;
      this.selectFileState(file.febosId);
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force fetch (if we change the page from 1 to 1 the watcher not run)
          await this.fetchDocuments();
        }
      }
    },
    clearFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      updateSearchParams({ page: 1 });
      this.$router.go();
    },
    getFilters() {
      // Esta condición es para ver referencias en base a febosId
      if (this.$route.query?.filters) {
        if (this.$route.query.filters.includes('febosId')) { return this.$route.query.filters; }
      }
      return mergeFilters(this.filters, this.$route.query.filters);
    },
    async exportList() {
      try {
        this.isExportingFiles = true;
        const filtroContent = this.textSearch !== '' ? `|content$${this.textSearch}` : '';
        const query = {
          campos: '*',
          page: this.page,
          order: '-fechaActualizacion',
          limit: this.rowspp,
          filter: this.getFilters() + filtroContent,
          formato: 'csv'
        };
        const { data: { url } } = await clListarDocumentosRecurrentes(query);
        window.open(url, '_blank');
        this.isExportingFiles = false;
      } catch (error) {
        console.error(error);
        this.isExportingFiles = false;
      }
    },
    async fetchDocuments() {
      const filtroContent = this.textSearch !== '' ? `|content$${this.textSearch}` : '';
      const query = {
        campos: '*',
        page: this.page,
        order: '-fechaActualizacion',
        limit: this.rowspp,
        filter: this.getFilters() + filtroContent
      };
      this.fetchBillings(query);
    }
  },
  created() {
    this.closeModal();
  },
  mounted() {
    this.fetchDocuments();
  }
};
</script>
<style>
.rowspp {

}
</style>
